import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IResource } from "@common/interfaces/resource";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";

export interface ResourceState extends EntityState<IResource, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.RESOURCES , realtimeEntity: 'Resource'})
export class ResourceStore extends EntityStore<ResourceState> {

  constructor() {
    super([]);
  }

}
